import { useMutation } from '@apollo/client/react';
import { useTheme } from '@emotion/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback, useEffect } from 'react';

import { Box, Button, EntryList, Modal } from '~/components/blocks';
import {
  DeletePatientAttachmentDocument,
  GetPatientAttachmentsDocument,
} from '~/graphql/generated/graphql';
import { deleteFileModalState } from '~/state/partials/delete_file_modal/atoms';
import { filePageInfoState } from '~/state/partials/patient_karte/atoms';

import { toPatientFrom } from '../PatientKarte/FilePane/FileList';

export const DeleteFileModal = () => {
  const theme = useTheme();
  const { patientId, filter, page, perPage } = useAtomValue(filePageInfoState);
  const state = useAtomValue(deleteFileModalState);
  const resetDeleteFileModal = useResetAtom(deleteFileModalState);

  const [deleteAttachment, { data, loading }] = useMutation(DeletePatientAttachmentDocument, {
    refetchQueries: [
      {
        query: GetPatientAttachmentsDocument,
        variables: {
          patientId,
          patientFrom: toPatientFrom(filter.sent, filter.received),
          page,
          perPage,
        },
      },
    ],
  });

  useEffect(() => {
    if (!data?.deletePatientAttachment?.patientAttachment) return;
    resetDeleteFileModal();
  }, [data, resetDeleteFileModal]);

  const handleClose = useCallback(() => resetDeleteFileModal(), [resetDeleteFileModal]);
  const handleClick = useCallback(() => {
    if (state.fileId) {
      deleteAttachment({
        variables: {
          input: {
            patientAttachmentId: state.fileId,
          },
        },
      });
    }
  }, [deleteAttachment, state.fileId]);

  return (
    <Modal open={state.isOpen} size="s" onClose={handleClose}>
      <Modal.Header>ファイル削除</Modal.Header>
      <Modal.Body>
        ファイルを削除してもよろしいですか。
        <Box marginTop={theme.space.m}>
          <EntryList>
            <EntryList.Head>ファイル名</EntryList.Head>
            <EntryList.Body>{state.fileName}</EntryList.Body>
          </EntryList>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button use="secondary" loading={loading} onClick={handleClick}>
          削除
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
